<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a :href="'/#/'">
            <i class="fa fa-home"></i>Home
          </a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">{{ folderName }}</li>
      </ol>
    </nav>
    <div class="card">
      <div class="card-header">
        <div class="card-title">JX Shuttle Bus Timetable (HQ)</div>
      </div>
      <div class="card-body">
        <form class="tran-select-area" @submit.prevent="handleSubmit">
          <div class="tran-input-group">
            <label>Departure</label>
            <select v-model="form.stationStart" class="form-control">
              <option value="">All</option>
              <option
                v-for="(station, idx) in busStationData"
                :key="idx"
                :value="station.stationCode"
              >
                {{ station.stationCode }}
              </option>
            </select>
          </div>
          <div class="tran-input-group">
            <label>Arrival</label>
            <select v-model="form.stationEnd" class="form-control">
              <option value="">All</option>
              <option
                v-for="(station, idx) in busStationData"
                :key="idx"
                :value="station.stationCode"
              >
                {{ station.stationCode }}
              </option>
            </select>
          </div>
          <div class="tran-input-group">
            <label>Depart at (GMT+8)</label>
            <div class="form-control date-input d-flex justify-content-between">
              <input v-model="form.expectDepartureDate" type="date" />
              <input v-model="form.expectDepartureTime" type="time" />
            </div>
          </div>
          <div class="tran-input-group">
            <label>Bus Type</label>
            <select v-model="form.busType" class="form-control">
              <option value="" selected>All</option>
              <option
                v-for="(type, idx) in busTypeList"
                :key="idx"
                :value="type.busType"
              >
                {{ type.busTypeEName }}
              </option>
            </select>
          </div>
          <button type="submit" class="tran-table-btn btn btn-block btn-primary">Search</button>
        </form>

        <div class="tran-table-outlay table-responsive px-2">
          <template v-if="!resultData.length">
            <div class="empty-outlay">
              <div v-if="isLoading" class="loading active">
                <div class="icon"><i class="fa fa-circle-o-notch fa-spin"></i></div>
              </div>
              <div v-else class="empty-status">
                <img src="/img/bus_no_result.svg" />
                <div class="title">No Result</div>
              </div>
            </div>
          </template>
          <template v-else>
            <table class="table table-hover">
              <thead>
                <tr class="head-fixed">
                  <th v-for="(field, idx) in fields" :key="idx">{{ field }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(bus, busIdx) in resultData" :key="busIdx">
                  <td v-for="(time, timeIdx) in formatBusTime(bus.stationInfos)" :key="timeIdx">
                    {{ time }}
                  </td>
                  <td>
                    {{ bus.busTypeEName }}
                    <br />
                    <span v-if="bus.vehicleTypeEName">({{ bus.vehicleTypeEName }})</span>
                  </td>
                  <td>{{ Array.isArray(bus.flightNOs) ? (bus.flightNOs).join(', ') : bus.flightNOs }}</td>
                </tr>
              </tbody>
            </table>
          </template>
        </div>
      </div>
      <ul class="card-footer pl-5">
        <li v-for="(note, idx) in busNoticeData" :key="idx" class="notice-text">{{ note }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TransPort',
  data: () => ({
    isLoading: false,
    folderName: '',
    form: {
      expectDepartureDate: '',
      expectDepartureTime: '',
      stationStart: '',
      stationEnd: '',
      busType: '',
      flightNO: '',
    },
    fields: [ 'FOC', 'T1', 'T2', 'FCCC','FOC', 'Bus Type', 'FlightNO.' ],
    busTypeList: [],
    busStationData: [],
    busNoticeData: [],
    resultData: [],
  }),
  methods: {
    // 過濾掉加班車的資料
    async handleSubmit() {
      this.isLoading = true;
      try {
        const res = await this.getBusTimeData(this.form);
        this.resultData = res.data.data.dataList.filter((item) => {
          return item.busType !== 'Charter';
        });
      } catch(err) {
        console.error(err);
      } finally {
        this.isLoading = false;
      }
    },
    async busNotice() {
      try {
        const res = await this.getBusNotice();
        this.busNoticeData = res.data.data.noteEContent;
      } catch(err) {
        console.error(err);
      }
    },
    // 站點只留'FOC', 'T1', 'T2'
    async busStations() {
      try {
        const res = await this.getBusStation();
        this.busStationData = res.data.data.dataList.filter((station) => {
          return ['FOC', 'T1', 'T2', 'FCCC'].includes(station.stationCode);
        });
      } catch(err) {
        console.error(err);
      }
    },
    async busType() {
      try {
        const res = await this.getBusType();
        this.busTypeList = res.data.data.dataList.filter((type) => {
          return type.busType !== 'Charter';
        });
      } catch(err) {
        console.error(err);
      }
    },
    formatBusTime(stationInfos) {
      const fieldsOrder = ['FOC', 'T1', 'T2', 'FCCC','FOC2'];
      const stations = {};
      let focCount = 0;
      const isFOCFirst = stationInfos.findIndex((item) => item.stationCode === 'FOC');

      stationInfos.forEach((item) => {
        const { stationCode, expectArrivalTime } = item;
        if (stationCode === 'FOC') {
          focCount++;
          stations[focCount === 1 && isFOCFirst === 0 ? 'FOC' : 'FOC2'] = expectArrivalTime;
        } else {
          stations[stationCode] = expectArrivalTime;
        }
      });

      return fieldsOrder.map(stationCode => stations[stationCode] || '-');
    },
  },
  async created() {
    this.folderName = this.$route.name;
    this.form.expectDepartureDate = this.$moment(new Date()).format('YYYY-MM-DD');
    this.form.expectDepartureTime = this.$moment(new Date()).format('HH:mm');
    this.isLoading = true;
    await Promise.all([
      this.busNotice(),
      this.busStations(),
      this.busType(),
    ]);
    await this.handleSubmit();
    this.isLoading = false;
  },
};
</script>

<style lang="scss" scoped>
.card {
  min-height: calc(100vh - 153px);
}

.tran-select-area {
  display: grid;
  align-items: end;
  grid-template-columns: repeat(5, 1fr);
  grid-gap: 20px;
  padding: 1rem;
  margin-bottom: 3rem;
}

.tran-input-group {
  label,select,input {
    font-size: 15px;
  }

  label {
    margin: 8px 0 5px 8px;
    color: #84754E;
    font-weight: bold;
  }

  .form-control {
    border-radius: 8px;
  }
}

.tran-table-btn {
  border-radius: 8px;
  font-size: 15px;
  width: 55%;
  min-width: fit-content;
  justify-self: end;
  white-space: nowrap;
}

.date-input {
  input {
    width: 48%;
    border: none;
  }
}

.tran-table-outlay {
  max-height: calc(100vh - 340px);
  overflow-y: auto;
  position: relative;
  margin-bottom: 4rem;

  .empty-outlay {
    min-height: 200px;
  }

  .loading {
    position: absolute;
    background: none;
    z-index: 1;
  }

  .icon {
    box-shadow: none;
  }

  .table {
    border-collapse: collapse;
    width: 100%;
    th,
    td {
      border-top: none;
      border-bottom: 1px solid #dee2e6;
      font-size: 15px;
      vertical-align: middle;
      text-align: center;
      white-space: nowrap;
      width: 100px;
      min-width: 100px;
      box-sizing: border-box;
    }

    thead th {
      background-color: #fff;
      border-bottom: 1px solid transparent;
      vertical-align: middle;
      white-space: nowrap;
    }

    td {
      white-space: normal;
    }
  }

  .table-hover {
    tbody tr:hover {
      box-shadow: 0 0 4px rgba(0, 0, 0, 0.08), 0 0 8px rgba(0, 0, 0, 0.08);
      background-color: #fff;
    }
  }
}

.head-fixed {
  position: sticky;
  top: 0px;
}

.notice-text {
  font-size: 13px;
  color: #666;
  list-style-type: disc;
}

@media screen and (max-width: 991px) {
  .card {
    min-height: calc(100vh - 190px);
  }
  .tran-select-area {
    grid-template-columns: 1fr 1fr 2fr 1fr 1fr;
  }
}

@media screen and (max-width: 767px) {
  .tran-select-area {
    grid-template-columns: repeat(1, 1fr);
    grid-gap: 0;
    padding: 0 0.5rem;
    margin-bottom: 0;
  }
  .tran-table-btn {
    margin: 2rem 0;
    width: 100%;
  }
  .tran-table-outlay {
    max-height: calc(100vh - 225px);
  }
}

@media screen and (max-height: 500px) {
  .tran-table-outlay {
    max-height: calc(100vh - 130px);
  }
}
</style>